import {
    Component
  } from '@angular/core';
  
  import * as moment from 'moment';
  
  
  export class NgxSchedulerCalendarHeaderComponent {
  
    public date = moment();
  
    selectNextDay() {
      this.date = this.date.add(1, 'd');
      console.log('date added')
    }
    selectPreviousDay() {
      this.date = this.date.subtract(1, 'd');
      console.log('date subtracted')
  
    }
  
  static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ngx-scheduler-calendar-header',
    template: `
      <div class="scheduler-container">
        <div class="" fxLayout="row" fxLayoutAlign="center center">
          <div fxLayoutAlign="center center" fxFlex><button class="toggle-btn toggle-btn-left" (click)="selectPreviousDay()"><</button></div>
        
  
          <div class="date-header" fxLayout="column" fxLayoutAlign="center center" flex>
            <h5 class="date-header-month">{{date.format('MMM')}}</h5>
            <h4 class="date-header-day">{{date.date()}}</h4>
          </div>
  
          <div fxLayoutAlign="center center" fxFlex><button class="toggle-btn toggle-btn-left" (click)="selectNextDay()">></button></div>
        </div>
      </div>
    `,
    styles: [`
  .scheduler-container {
    border: 1px solid black;
    margin:2px;
  }
  
  .date-header {
    padding:2px 4px;
    text-align: center;
    flex-grow: 2;
  }
  
  .date-header-month {
    margin: 0;
  }
  .date-header-day {
    margin: 0;
  }
  
  .toggle-btn {
    background-color: Transparent;
    background-repeat:no-repeat;
    border: none;
    cursor:pointer;
    overflow: hidden;
    outline:none;
  }
  
  .toggle-btn-left {
     background-color:none;
  }
  
  .toggle-btn-right {
      float:right;  
  }
  
    `]
  }, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
  
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
